module.exports = __webpack_public_path__ + "img/speaker-fill.4f141949.svg";